import { ThemeSelector } from "@/components/ThemeSelector";
import { LiveFeed } from "@/components/LiveFeed";
import { FoundationLine, AboutButton } from "@/components/FoundationLine";
import { SentenceClock } from "@/components/SentenceClock";
import { FoundationDonations } from "@/components/FoundationDonations";
import { ClockRecordTitle } from "@/components/ClockRecord";

export default function HomePage() {
  return (
    <div className="flex flex-col items-center pb-16" style={{ marginTop: "2vh" }} data-testid="home-page">
      <AboutButton />
      <FoundationLine />
      <LiveFeed />
      <ClockRecordTitle />
      <SentenceClock />
      <FoundationDonations />
      <ThemeSelector inline />
    </div>
  );
}
